import LoadingScreen from '../../components/LoadingScreen'

function SSO () {
  return (<LoadingScreen />)
}

export default SSO
